import './App.css';
import AllRoutes from './pages/AllRoutes';



function App() {

  return (
    <div className="App">
      <AllRoutes/>
    
    </div>
  );
}

export default App;
